import { AppMarketsEnum } from '../enums/app-markets';
export const GET_APP_PAGE_PATH = '/download';
export const GOOGLE_PLAY_APP_PATH = 'https://play.google.com/store/apps/details?id=com.sweatpals.sweatpals_app';
export const APP_STORE_APP_PATH = 'https://apps.apple.com/us/app/sweatpals/id1595991156';
export const TYPEFORM_PAGE_PATH = 'https://o6x5kiuan5o.typeform.com/to/P2SbIGxS?typeform-source=www.sweatpals.com';
export const TYPEFORM_URL = 'https://svl3z49916w.typeform.com/hellosweatpals?typeform-source=www.sweatpals.com';
export const TYPEFORM_AMBASSADOR_URL = 'https://svl3z49916w.typeform.com/SweatPals?typeform-source=linktr.ee';
export const SHOP_SWEATPALS_URL = 'https://shop.sweatpals.com';
export const CAREER_PAGE_URL = 'https://jobs.ashbyhq.com/sweatpals';
// export const OWNER_EMAIL = 'salar@sweatpals.com';
export const CONTACT_US_SEND_EMAIL = 'hello@sweatpals.com';

export const APP_LINKS = {
	[AppMarketsEnum.AppStore]: {
		link: APP_STORE_APP_PATH,
		name: AppMarketsEnum.AppStore,
	},
	[AppMarketsEnum.PlayMarket]: {
		link: GOOGLE_PLAY_APP_PATH,
		name: AppMarketsEnum.PlayMarket,
	},
};

export const SOCIAL_MEDIA_LINKS = {
	instagram: 'https://www.instagram.com/sweatpalsapp',
	tiktok: 'https://www.tiktok.com/@sweatpals',
	facebook: 'https://www.facebook.com/SweatPalsATX',
};
